import {
  CaretLeft,
  CirclesThreePlus,
  Minus,
  Scroll,
  Spinner,
  // Star,
  Storefront,
  Truck,
  X,
} from "@phosphor-icons/react";
import { Plus } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useProductDetails from "../../hooks/useProductDetails";
import moment from "moment";
import { HashLoader } from "react-spinners";
import { formatAsMoney } from "../../helpers/numbers";
import { motion } from "framer-motion";
import { useAddToCart } from "../../hooks/useAddToCart";
import { toast } from "sonner";
import { CartData } from "../../@types";
import { normalizeStorageUrl } from "../../helpers/assetUrl";
// import useProductDetails from "../../hooks/useProductDetails";

const ProductDetails = () => {
  // const [rating] = useState(Math.floor(Math.random() * 5));
  const [quantity, setQuantity] = useState(1);

  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const [imageIsFullscreen, setImageIsFullscreen] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  const { addToCart, addingToCart } = useAddToCart({
    onSuccess(_, payload) {
      toast.success(
        `${productDetails?.data?.name} x${payload.quantity} added to cart`
      );
    },
    onError(e) {
      toast.error(e.message);
    },
  });

  const { productId } = useParams();

  const { product: productDetails, isLoading } = useProductDetails(productId!!);
  const activeImageSrc = normalizeStorageUrl(
    productDetails?.data?.images[activeImageIndex]?.path
  );

  const navigate = useNavigate();

  useEffect(() => {
    setImageFailed(false);
  }, [activeImageIndex, activeImageSrc]);

  return isLoading ? (
    <div className="fixed top-0 z-50 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
      <HashLoader />
    </div>
  ) : productDetails?.data ? (
    <div className="p-10 py-5 md:py-10 px-5 md:px-10">
      <div className="max-w-5xl mx-auto flex flex-col gap-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10">
          <div className="md:col-span-3 flex items-start">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="p-2 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300 self-start"
            >
              <CaretLeft weight="bold" />
              <span>Back</span>
            </button>
          </div>
          <div className="flex flex-col gap-2">
            {imageIsFullscreen ? (
              <motion.div className="fixed left-0 right-0 w-screen h-screen top-0 p-10 flex items-center justify-center bg-gray-100 z-[999999]">
                <button
                  onClick={() => {
                    setImageIsFullscreen(false);
                  }}
                  type="button"
                  className="absolute top-10 right-10 bg-gray-50 border rounded-full p-4"
                >
                  <X size={24} />
                </button>
                <motion.div
                  layoutId="productImageContainer"
                  className="aspect-square max-w-3xl w-full rounded-md overflow-hidden"
                >
                  {activeImageSrc && !imageFailed ? (
                    <motion.img
                      layoutId="productImage"
                      transition={{
                        type: "tween",
                      }}
                      src={activeImageSrc}
                      alt="Bag"
                      onError={() => setImageFailed(true)}
                      className="aspect-square object-cover hover:scale-105 duration-500 border rounded-md  max-w-3xl w-full"
                    />
                  ) : (
                    <div className="w-full h-full flex justify-center items-center text-visaro-primary-700">
                      <CirclesThreePlus size={50} />
                    </div>
                  )}
                </motion.div>
              </motion.div>
            ) : activeImageSrc && !imageFailed ? (
              <motion.div
                onClick={() => {
                  setImageIsFullscreen(true);
                }}
                layoutId="productImageContainer"
                className="bg-gray-100 aspect-square w-full rounded-md overflow-hidden border"
              >
                <motion.img
                  transition={{
                    bounce: 0,
                  }}
                  layoutId="productImage"
                  src={activeImageSrc}
                  alt="Bag"
                  onError={() => setImageFailed(true)}
                  className="w-full h-full aspect-square object-cover hover:scale-105 duration-500 "
                />
              </motion.div>
            ) : (
              <div className="w-full h-full flex justify-center items-center text-visaro-primary-700 bg-gray-100 rounded-md border">
                <CirclesThreePlus size={50} />
              </div>
            )}
            <div className="grid grid-cols-5 gap-2">
              {productDetails?.data?.images.map((image, index) => {
                return (
                  <img
                    onClick={() => {
                      setActiveImageIndex(index);
                    }}
                    key={image.id}
                    src={normalizeStorageUrl(image.path)}
                    alt="Bag"
                    className="w-full h-full aspect-square object-cover hover:scale-105 duration-500 rounded-xl border hover:border-deepBlue  cursor-pointer"
                  />
                );
              })}
            </div>
          </div>
          <div className="md:col-span-2 flex flex-col gap-2">
            <div className="text-3xl font-medium">
              {productDetails?.data.name}
            </div>

            <div className="text-gray-700 text-lg">
              {productDetails?.data?.description}
            </div>
            <div className="text-xl lg:text-2xl font-medium">
              ₦{formatAsMoney(productDetails?.data?.price)}
            </div>
            {/* <div className="flex items-end gap-0.5 py-2">
              {new Array(5).fill(0).map((_, key) => {
                return (
                  <Star
                    weight={rating > key ? "fill" : "regular"}
                    key={key}
                    size={22}
                    className={`
                      ${rating > key ? "text-visaro-orange" : "text-gray-500"}
                      `}
                  />
                );
              })}
              <span className="text-xs">(200)</span>
            </div> */}
            <div className="flex items-center gap-4 text-lg">
              <button
                type="button"
                onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))}
                className="p-2 rounded-full border border-gray-300 hover:bg-gray-200 text-visaro-orange"
              >
                <Minus />
              </button>
              <span>{quantity}</span>
              <button
                disabled={
                  productDetails?.data?.quantity -
                    productDetails?.data?.sales_count ===
                  quantity
                }
                type="button"
                onClick={() => setQuantity((prev) => prev + 1)}
                className="p-2 rounded-full border border-gray-300 hover:bg-gray-200 text-visaro-orange"
              >
                <Plus />
              </button>
            </div>
            <div className="py-2 flex items-center gap-5">
              <button
                disabled={addingToCart}
                onClick={() => {
                  if (productDetails?.data?.id) {
                    addToCart(
                      {
                        product_id: productId!!,
                        quantity: quantity,
                      },
                      {
                        onSuccess: (data) => {
                          const cart = data?.data as CartData | undefined;

                          if (cart?.id) {
                            navigate(`/marketplace/checkout/${cart.id}`);
                            return;
                          }

                          toast.error(
                            "Product added, but checkout could not be started. Please open your cart to continue."
                          );
                        },
                      }
                    );
                  }
                }}
                className="p-4 px-5 w-full border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm flex-1 flex items-center justify-center"
              >
                {addingToCart ? (
                  <Spinner className="animate-spin" size={20} />
                ) : (
                  "Buy"
                )}
              </button>
              <button
                disabled={addingToCart}
                onClick={() => {
                  if (productDetails?.data?.id) {
                    addToCart({
                      product_id: productId!!,
                      quantity: quantity,
                    });
                  }
                }}
                className="p-4 px-5 w-full border-visaro-gray-700 border rounded-lg font-bold bg-transparent text-deepBlue text-sm flex-1 flex items-center justify-center"
              >
                {addingToCart ? (
                  <Spinner className="animate-spin" size={20} />
                ) : (
                  "Add to Cart"
                )}
              </button>
            </div>
            <div className="border-gray-200 text-gray-700 border rounded-md flex-col">
              <div className="flex items-center gap-2 p-3 px-4">
                <Truck size={20} className="text-visaro-orange" />
                <div>7 days delivery</div>
              </div>
              <hr />
              <div className="flex items-center gap-2 p-3 px-4">
                <Scroll size={20} className="text-visaro-orange" />
                <Link to="/legal" className="underline">
                  View Return Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <div className="font-medium text-xl">Product Description</div>
          <div className="text-gray-700 text-lg">
            {productDetails?.data?.description}
            <div className="flex gap-2">
              <div className="font-medium">Availability</div>
              <div>
                {productDetails?.data?.quantity -
                  productDetails?.data?.sales_count}{" "}
                Left
              </div>
            </div>
          </div>
        </div>
        {productDetails?.data?.merchant && (
          <div className="flex flex-col gap-5">
            <div className="font-medium text-xl">Merchant</div>
            <div className="text-gray-700 text-lg p-2 bg-gray-50 flex flex-col gap-4">
              <div className="flex gap-4">
                <div className="w-16 h-16 flex justify-center items-center rounded-md bg-gray-100 text-visaro-orange">
                  <Storefront size={30} />
                </div>
                <div className="flex items-start flex-col text-deepBlue gap-2">
                  <div>
                    <div className="font-medium">
                      {productDetails?.data?.merchant?.business_name}
                    </div>
                    <div className="text-sm flex items-center gap-2">
                      <span>
                        Vendor since{" "}
                        {moment(
                          productDetails?.data?.merchant?.validated_at
                        ).fromNow()}
                      </span>
                      <span className="text-visaro-orange">·</span>
                      <span>{productDetails?.data?.merchant?.country_id}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Link
                  to={`/marketplace/merchants/${productDetails?.data?.merchant.id}`}
                  className="border border-gray-300 rounded-full text-sm px-4 py-1"
                >
                  View Products
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="p-5 aspect-video flex items-center justify-center">
      Product Not Found
    </div>
  );
};

export default ProductDetails;
